export const STRATIFY_APP_RETURN = 'stratify://billing/return';
export function billingReturnTrace(event, fields = {}) {
  const allowed = ['phase', 'attempt', 'plan', 'revision', 'status', 'elapsedMs', 'signedIn', 'targetPlan', 'providerCheckedAt', 'correlationId', 'offerKey'];
  const safe = Object.fromEntries(Object.entries(fields).filter(([key]) => allowed.includes(key)));
  console.info('[BILLING_DEBUG_WEB]', { event, at: new Date().toISOString(), ...safe });
}
